import moment from 'moment';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import LocationMark from '../Icons/LocationMark';

const LiveClock = () => {
  const [currentTime, setCurrentTime] = useState(moment());
  const userDetails = useSelector((state: RootState) => state.user.user);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    return () => clearInterval(timer);
  }, []);
  return (
    <>
      <h2>{currentTime.format('hh:mm:ss A')}</h2>
      <p>{currentTime.format('MMM DD, YYYY - dddd')}</p>
      {/* <p className="fs-5">
        Shift Time: {
          moment(userDetails?.Shift?.startTime, 'HH:mm:ss').format('hh:mm A')} -
        {moment(userDetails?.Shift?.endTime, 'HH:mm:ss').format('hh:mm A')
        }
      </p> */}
      <p className="fs-4">
        <LocationMark />
        {userDetails?.site?.name?.toUpperCase() || 'No Site Available'} -
        <span className="fs-5 ">{userDetails?.site?.address}</span>
      </p>
    </>
  );
};

export default LiveClock;
